import { makeStyles } from '@material-ui/core/styles'
import cx from 'classnames'
import React from 'react'

import styles from './styles'

const useStyles = makeStyles(styles)

/**
 * @typedef {{
 *   width?: string;
 *   height?: string;
 *   className?: string;
 *   color?: 'primary' | 'secondary' | 'white';
 *   align?: string;
 * } & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>} UnderlineProps
 */

/**
 * ```
 * import { Underline } from '@pickupp/ui/core'
 * ```
 */

/**
 * @param {UnderlineProps} props
 */
const Underline = (props) => {
  const {
    width = '3rem',
    height = '4px',
    className,
    color = 'primary',
    align = 'center',
    ...extraProps
  } = props
  const classes = useStyles({
    width,
    height,
    className,
    color,
    align,
  })

  return (
    <div
      {...extraProps}
      className={cx(props.className, classes.mainContainer)}
    />
  )
}

export default Underline
